import Navbar from "../components/Navbar";
import Directory from "../components/Directory";
import Footer from "../components/Footer";
import FinalCTA from "../components/FinalCTA";

export default function DirectoryPage() {
    return (
        <div className="bg-background text-foreground min-h-screen">
            <Navbar />
            <main data-testid="directory-page" className="pt-[4.75rem]">
                <section className="relative overflow-hidden bg-gradient-to-b from-slate-950 via-slate-900 to-slate-950 text-white">
                    <div className="absolute inset-0 opacity-20">
                        <img
                            src="https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?auto=format&fit=crop&w=1800&q=85"
                            alt=""
                            className="w-full h-full object-cover"
                        />
                    </div>
                    <div className="absolute inset-0 bg-gradient-to-b from-slate-950/70 via-slate-950/78 to-slate-950/92" />
                    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-14 md:pt-20 pb-14 md:pb-16">
                        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white/10 text-emerald-300 text-xs font-semibold border border-white/15 mb-6">
                            Treatment Directory
                        </div>
                        <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight max-w-4xl">
                            Verified recovery resources, nationwide
                        </h1>
                        <p className="mt-5 text-lg text-white/75 max-w-3xl">
                            Private, judgment-free search across sober living homes, rehabs,
                            outpatient programs, and community resources. Search privately, filter
                            quickly, and move from digital support to real-world care at your own pace.
                        </p>
                        <div className="mt-8 grid sm:grid-cols-3 gap-4 max-w-4xl">
                            {[
                                "Browse by state, keyword, and program type",
                                "Verified listings tied to a privacy-first philosophy",
                                "A natural extension of Hope and the Genesis platform",
                            ].map((item) => (
                                <div
                                    key={item}
                                    className="rounded-2xl border border-white/10 bg-white/5 px-4 py-4 text-sm text-white/85 backdrop-blur-sm"
                                >
                                    {item}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>
                <Directory mode="full" />
                <FinalCTA />
            </main>
            <Footer />
        </div>
    );
}
